/**
 * The key used on your feature flag will be the key you supply in the url.
 * Where as the `flagKey` is what we use in code to identify the feature.
 * ie. If your object is :
 * CONFIG = {
 *     'COOL-THING' : {flagKey: 'SOMETHING.FEATURE' }
 * }
 * then the url should be `?ff.COOL-THING=true`
 * In your JS/React, you would check if the feature exists using the flagKey though.
 */
const CONFIG = {};

export default CONFIG;
